

























import { clamp } from 'lodash'
import { Component, Prop, VModel, Mixins } from 'vue-property-decorator'

import { isNumber } from "../../shared/utils/isNumber";
import PeriodSimplifierMixin from "./PeriodSimplifierMixin";
import { StepUnit, TimeUnitInputMode, StepUnitAlias } from './types'

const defaultUnits: Array<StepUnit> = [ StepUnit.Second, StepUnit.Minute, StepUnit.Hour, StepUnit.Day, StepUnit.Week, StepUnit.Month ]

@Component
export default class PeriodSimplifier extends Mixins(PeriodSimplifierMixin) {
  @VModel({ type: [ Number, String ] }) modelValue!: number | string | null

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop({ type: Array, default: (): Array<StepUnit> => defaultUnits }) units!: Array<StepUnit>

  @Prop({ type: Number, default: (): StepUnit => StepUnit.Second }) readonly step!: StepUnit

  @Prop({ type: Number, default: 0 }) min!: number

  @Prop({ type: Number, default: Number.MAX_SAFE_INTEGER }) max!: number

  @Prop({ default: 1 }) mode!: TimeUnitInputMode

  @Prop() onUnitChange!: (type: StepUnitAlias) => void

  @Prop() initUnit!: StepUnitAlias

  opts() {
    return [
      {
        alias: StepUnitAlias.SECONDS,
        unit: StepUnit.Second,
        value: StepUnit.Second / this.step,
        label: this.getLabel(StepUnit.Second)
      },
      {
        alias: StepUnitAlias.MINUTES,
        unit: StepUnit.Minute,
        value: StepUnit.Minute / this.step,
        label: this.getLabel(StepUnit.Minute)
      },
      {
        alias: StepUnitAlias.HOURS,
        unit: StepUnit.Hour,
        value: StepUnit.Hour / this.step,
        label: this.getLabel(StepUnit.Hour)
      },
      {
        alias: StepUnitAlias.DAYS,
        unit: StepUnit.Day,
        value: StepUnit.Day / this.step,
        label: this.getLabel(StepUnit.Day)
      },
      {
        alias: StepUnitAlias.WEEKS,
        unit: StepUnit.Week,
        value: StepUnit.Week / this.step,
        label: this.getLabel(StepUnit.Week)
      },
      {
        alias: StepUnitAlias.MONTHS,
        unit: StepUnit.Month,
        value: StepUnit.Month / this.step,
        label: this.getLabel(StepUnit.Month)
      },
    ]
  }

  numericModelValue(value: string | number | null): number {
    if (isNumber(value)) {
      return value as number
    } else if (typeof value === 'string' && !Number.isNaN(Number.parseInt(value))) {
      return Number.parseInt(value)
    } else {
      return 0
    }
  }

  get unitOptions() {
    return this.opts()
      .filter(o => this.units.includes(o.unit))
  }

  get modelValueComputed(): number {
    if (this.mode === TimeUnitInputMode.Converter) {
      return this.numericModelValue(this.modelValue) / (this.currentUnit as StepUnit)
    } else {

      return this.numericModelValue(this.modelValue)
    }
  }

  set modelValueComputed(value: number | string) {
    const numValue = this.numericModelValue(value)

    if (this.currentUnit) {
      if (this.mode === TimeUnitInputMode.Converter) {
        this.modelValue = clamp(numValue, this.min / this.currentUnit, this.max) * this.currentUnit
      } else {
        this.modelValue = numValue
      }
    }
  }

  getLabel(val: number) {
    return this.unitLabel(val, this.modelValueComputed)
  }

  // this.calculateCurrentUnit(this.unitOptions.map(u => u.value), Math.abs(this.numericModelValue), this.unitOptions[0].value)

  // calculateCurrentUnit(): void {
  //   const time = Math.abs(this.numericModelValue)
  //
  //   if (time !== 0) {
  //     for (const unitOption of this.unitOptions) {
  //       const unit: StepUnit = unitOption.value
  //       const remainder = time % unit
  //       if (time >= unit && remainder === 0) {
  //         this.currentUnit = unit
  //       }
  //     }
  //   } else {
  //     this.currentUnit = this.unitOptions[0].value
  //   }
  // }

  onCurrencyInputSelect(value: StepUnit, prevValue: StepUnit): void {
    if (this.mode === TimeUnitInputMode.Fixed) {
      this.modelValueComputed = this.numericModelValue(this.modelValue)
    } else {
      this.modelValueComputed = this.numericModelValue(this.modelValue) / prevValue
    }

    const item = this.unitOptions.find(o => o.value === value)

    if (item && typeof this.onUnitChange=== 'function') {
      this.onUnitChange(item.alias)
    }
  }

  created(): void {
    this.calculateCurrentUnit(this.unitOptions.map(u => u.value), Math.abs(this.numericModelValue(this.modelValue)), this.unitOptions[0].value)
    this.$watch('currentUnit', this.onCurrencyInputSelect)

    if (this.mode === TimeUnitInputMode.Fixed) {
      const item = this.unitOptions.find(o => o.alias === this.initUnit)

      if (this.currentUnit && item) {
        this.currentUnit = item.value
        this.onUnitChange(item.alias)
      }
    }
  }
}
